export default __webpack_public_path__ + "static/media/household-keymap-12-3@2x.4d6ed59e.png";